import { createBrowserHistory } from 'history'

const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL
});

export function push(location) {
    history.push(location);
}

export function goBack() {
    history.back();
}

export default history;
